import { render, staticRenderFns } from "./DateTimeDeadline.vue?vue&type=template&id=4a112b34"
import script from "./DateTimeDeadline.vue?vue&type=script&lang=js"
export * from "./DateTimeDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports